package one.healthium.log_water.ui.internal

import androidx.compose.runtime.Immutable

@Immutable
internal data class LogWaterUiState(
    val loading: Boolean = false,
    val waterIntake: LogWaterUiModel? = null,
    val isMetric: Boolean = false,
)
